import { Role } from "../api";
import { partnersService } from "../modules/api_client";
import type { PartnerDto } from "../api";
import { useApi } from "./useApi";
import { useMe } from "./useMe";

export function useMePartner() {
  const { user, isLoading: isLoadingUser } = useMe();
  const shouldFetchPartner = !isLoadingUser && user?.role !== Role.Admin;

  const {
    data: partner,
    mutate,
    isLoading,
    error,
  } = useApi<PartnerDto>(
    shouldFetchPartner ? "me-partner" : null,
    () => partnersService.getCurrentUserPartner(),
  );

  const isSeller = (partner?.supplierRank ?? 0) > 0;
  const isBuyer = (partner?.customerRank ?? 0) > 0 && !isSeller;

  return {
    partner,
    mutate,
    isLoading: isLoadingUser || isLoading,
    error,
    isBuyer,
    isSeller,
  };
}
